module.exports = __webpack_public_path__ + "img/top10-bn.0d6b493b.png";